import React, { useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Accounts from "./Accounts";
import InputSalesInvoices from "./InputSalesInvoices";
import InputSalesInvoiceProductReview from "./InputSalesInvoiceProductReview";
import InvoiceInformationReview from "./InvoiceInformationReview";

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
}));

function SalesInvoiceInputMain(props) {
  const theme = useTheme();

  const [openInputDialog, setOpenInputDialog] = React.useState(false);
  const [openProductReviewDialog, setOpenProductReviewDialog] = React.useState(false);
  const [openInvoiceInformationReviewDialog, setOpenInvoiceInformationReviewDialog] =
    React.useState(false);
  const [selectedAccount, setSelectedAccount] = useState();
  const [reloadAccounts, setReloadAccounts] = useState(false);
  const openDialogInputHandleClick = (account) => {
    setSelectedAccount(account);
    setOpenInputDialog(true);
  };
  const closeDialogInputDialog = () => {
    setOpenInputDialog(false);
  };
  const closeThenOpenInputDialog = () => {
    setOpenInputDialog(false);
    setTimeout(function () {
      setOpenInputDialog(true);
    }, 1000);
  };
  const openProductReviewDialogHandleClick = () => {
    setOpenProductReviewDialog(true);
  };
  const closeProductReviewDialogHandleClick = () => {
    setOpenProductReviewDialog(false);
  };

  const openInvoiceInformationReviewDialogHandleClick = () => {
    setOpenInvoiceInformationReviewDialog(true);
  };
  const closeInvoiceInformationReviewDialogHandleClick = () => {
    setOpenInvoiceInformationReviewDialog(false);
  };

  const closeAllDialog = () => {
    setOpenInputDialog(false);
    setOpenProductReviewDialog(false);
    setOpenInvoiceInformationReviewDialog(false);
  };
  return (
    <div>
      <Accounts
        handleDrawerToggle={props.handleDrawerToggle}
        openDialogInputHandleClick={openDialogInputHandleClick}
        reloadAccounts={reloadAccounts}
        setReloadAccounts={setReloadAccounts}
      />
      {openInputDialog ? (
        <InputSalesInvoices
          selectedAccount={selectedAccount}
          closeThenOpenInputDialog={closeThenOpenInputDialog}
          closeDialogInputDialog={closeDialogInputDialog}
          openInputDialog={openInputDialog}
          openProductReviewDialogHandleClick={openProductReviewDialogHandleClick}
        />
      ) : (
        ""
      )}

      <InputSalesInvoiceProductReview
        selectedAccount={selectedAccount}
        closeProductReviewDialogHandleClick={closeProductReviewDialogHandleClick}
        openProductReviewDialog={openProductReviewDialog}
        openInvoiceInformationReviewDialogHandleClick={
          openInvoiceInformationReviewDialogHandleClick
        }
      />
      <InvoiceInformationReview
        closeInvoiceInformationReviewDialogHandleClick={
          closeInvoiceInformationReviewDialogHandleClick
        }
        openInvoiceInformationReviewDialog={openInvoiceInformationReviewDialog}
        closeAllDialog={closeAllDialog}
        selectedAccount={selectedAccount}
        reloadAccounts={reloadAccounts}
        setReloadAccounts={setReloadAccounts}
      />
    </div>
  );
}

export default SalesInvoiceInputMain;
